module.exports = __webpack_public_path__ + "img/ranking.934ec216.png";